document.querySelectorAll(".faq-question").forEach(button => {
    const wrapper = button.closest(".faq-wrapper");
    const answerWrapper = wrapper.querySelector(".faq-answer-wrapper");

    const toggle = () => {
        const isActive = wrapper.classList.toggle("active");
        button.setAttribute("aria-expanded", isActive ? "true" : "false");
        answerWrapper.hidden = !isActive;
        answerWrapper.style.maxHeight = isActive ? answerWrapper.scrollHeight + "px" : null;
    }

    button.addEventListener("click", toggle);

    button.addEventListener("keydown", e => {
        if(e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle();
        }
    });
});